import React from 'react';
import {ScrollView, View} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {
  Code,
  FlexView,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';

import {Loading} from '../Loading';
import PersonListItem from '../PersonListItem';

import {styles} from './PersonListItem.style';

storiesOf('base', module).add('PersonListItem', () => (
  <ScrollView>
    <FlexView>
      <Spacing size={20}>
        <Heading level={1}>Person List Item Component</Heading>
        <Spacer size={16} />
        <Text>
          The <Code>{'PersonListItem'}</Code> component is based off the{' '}
          <Code>{'ListItem'}</Code> component and returns a list item with a
          user's information.
        </Text>
        <Spacer size={16} />
        <Text>
          The <Code>{'PersonListItem'}</Code> accepts a <Code>{'name'}</Code>,{' '}
          <Code>{'role'}</Code> and <Code>{'attribute'}</Code> prop.
        </Text>
        <Spacer size={16} />
        <Text>
          If no <Code>{'avatarUrl'}</Code> is supplied, the avatar will render a
          randomly generated avatar. <Code>{'avatarEmail'}</Code> can be
          supplied to seed the randomization of the generated avatar.{' '}
          <Code>{'isCoach'}</Code> prop will determine the variation of the
          avatar.
        </Text>
      </Spacing>
      <Spacing size={20}>
        <Heading level={2}>Default Layout</Heading>
      </Spacing>
      <View style={styles.wrapper}>
        <Gutter style={styles.gutter}>
          <PersonListItem
            name="Bob Nunez"
            role="Business Leader"
            avatarEmail="bob@medifast.co"
          />
        </Gutter>
      </View>
      <Spacing size={20}>
        <Code>{'name="Bob Nunez" role="Business Leader"'}</Code>
      </Spacing>
      <Spacing size={20}>
        <Heading level={2}>With Attribute Prop</Heading>
      </Spacing>
      <View style={styles.wrapper}>
        <Gutter style={styles.gutter}>
          <PersonListItem
            name="Bob Nunez"
            role="Business Leader"
            avatarEmail="b.nunez@medifast.co"
            attribute={<Text>Sponsored 2 days ago by Randall McCormick</Text>}
          />
        </Gutter>
      </View>
      <Spacing size={20}>
        <Code>{'attribute={<Text>Sponsored...</Text>}'}</Code>
      </Spacing>
    </FlexView>
    <Spacing size={20}>
      <Heading level={2}>Loading Layout</Heading>
    </Spacing>
    <View style={styles.wrapper}>
      <Gutter style={styles.gutter}>
        <Loading />
      </Gutter>
    </View>
    <Spacer size={20} />
  </ScrollView>
));
